import type { DocumentHeaderCandidates } from '@avisoma/shared';
import { presentDocumentHeaderGroups } from './documentHeaderPresentation';

export function DocumentHeadersCard({ headers }: { headers: DocumentHeaderCandidates | undefined }) {
  const groups = presentDocumentHeaderGroups(headers);
  if (groups.length === 0) return null;

  return (
    <div className="bg-white dark:bg-zinc-800 shadow dark:shadow-zinc-950/30 rounded-lg overflow-hidden border border-gray-200 dark:border-zinc-700">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-zinc-700">
        <h2 className="text-sm font-medium text-gray-900 dark:text-zinc-100">Document Headers</h2>
      </div>
      <div className="px-4 py-4 space-y-4">
        {groups.map((group) => (
          <div key={group.key}>
            <h3 className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-zinc-400">
              {group.label}
            </h3>
            <dl className="mt-2 grid grid-cols-3 gap-4">
              {group.fields.map(([label, value]) => (
                <div key={label}>
                  <dt className="text-sm font-medium text-gray-500 dark:text-zinc-400">{label}</dt>
                  <dd className="mt-1 text-sm text-gray-900 dark:text-zinc-100">{value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </div>
  );
}
